import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";

import CRResultScreen from '../../components/CRResultScreen';

class ResultContainer extends Component {
	render() {
		return (
			<CRResultScreen 
				transitionOut={this.props.transitionOut}
				status={this.props.status}	
				points={this.props.points}
				sounds={this.props.sounds}
			/>
		);
	}
}

const mapStateToProps = state => ({
	sounds: state.audio.sounds,
	status: state.game.status,
	points: state.game.points
 });
 
 const mapDispatchToProps = dispatch => ({
 });
 
 ResultContainer.propTypes = {
	// quizQuestions: PropTypes.array.isRequired,
	// showAnswer: PropTypes.bool.isRequired,
	// index: PropTypes.number.isRequired,
	// onAnswerSelected: PropTypes.func.isRequired
 };
 
 export default connect(
	mapStateToProps,
	mapDispatchToProps
 )(ResultContainer);


// WEBPACK FOOTER //
// ./src/containers/ChainReactionGame/ResultContainer.js